module.exports = __webpack_public_path__ + "img/1543619461.d385e72e.jpg";